const ConfigActionTypes = Object.freeze({
  CONFIG_UPDATE: "CONFIG_UPDATE",
});

export default ConfigActionTypes;
